import React, { useState, useRef } from "react";
import { Switch, Tooltip } from "@mui/material";
import { callAPI } from "../../../axios";
import BasicModal from "../../core/BaseComponents/Modal";

const EnableDisablePartnerConfig = (props) => {

  const [modal, setShowModal] = useState(false);
// console.log(props);

  const isRoomTypeEnableModalRef = useRef({
    isRoomTypeConfirmationModalData: null,
    roomTypeConformationModalData: null,
  });

  const handleToggleChange = (e, row) => {
    const sid = row.sid;
    const isEnabled = !row?.active;
    setShowModal(true);
    const newModalRefData = {
      isRoomTypeConfirmationModalData: {
        sid,
        isEnabled,
      },
      roomTypeConformationModalData: null,
    };
    isRoomTypeEnableModalRef.current = newModalRefData;
  };

  const enabledTrue = () => {
    const { sid, isEnabled } =
      isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData;
    props.setLoader(true);
    callAPI(`/package-activity-enable?sid=${sid}&active=${isEnabled}`, "PUT")
      .then(() => {
        props.setLoader(false);
        const newModalRefData = {
          isRoomTypeConfirmationModalData: null,
          roomTypeConformationModalData: {
            userIsEnabled: isEnabled,
          },
        };
        isRoomTypeEnableModalRef.current = newModalRefData;
        props?.hotelServiceListApi();
      })
      .catch((error) => {
        props.setLoader(false);
        setShowModal(false);
        console.warn(error)
      });
  };

  return (
    <>
      {Boolean(props?.editHotelSid?.sid && props?.editHotelSid?.sid === props?.row?.sid) ? <Tooltip title='Cancel edit mode to perform actions' arrow>
        <Switch
          name="active"
          inputProps={{ "aria-label": "controlled" }}
          value={props?.row.active}
          checked={props?.row.active}
          className={`${props?.row.active === false ? 'switchuser-inactive' : 'switchuser-active'} edit-icon-disable`}
        />
      </Tooltip> : <Tooltip title={props?.row.active ? "Active" : "Inactive"} arrow>
        <Switch
          name="active"
          onChange={(event) => handleToggleChange(event, props?.row)}
          inputProps={{ "aria-label": "controlled" }}
          value={props?.row.active}
          checked={props?.row.active}
          className={`${props?.row.active === false ? 'switchuser-inactive' : 'switchuser-active'}`}
        />
      </Tooltip>}

      <BasicModal
        popupOpen={modal}
        footer={
          isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData
            ? {
              primaryButton: {
                action: () => setShowModal(false),
                buttonName: "Cancel",
              },
              secondaryButton: {
                action: enabledTrue,
                buttonName: "Yes",
              },
            }
            : {
              secondaryButton: {
                action: () => setShowModal(false),
                buttonName: "OK",
              },
            }
        }
        bodyMessage={
          <>
            {isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData && (
              <div className="pop-up-design">
                {isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData?.isEnabled ? <img className="mb-2 image-enable-disble" src='/Images/enabled.png' /> : <img className="mb-2 image-enable-disble" src='/Images/disabled.png' />}
                <p>
                  Do you really want to
                  {isRoomTypeEnableModalRef.current?.isRoomTypeConfirmationModalData
                    ?.isEnabled
                    ? " Enable "
                    : " Disable "}
                  this Master APK Configuration ?
                </p>
              </div>
            )}
            {isRoomTypeEnableModalRef.current?.roomTypeConformationModalData && (
              <div>
                <span className='d-block'><img src='/Images/approve-qc.png' className="image-enable-disble" /></span>
                <p className="enable mt-3">
                Master APK config
                  {isRoomTypeEnableModalRef.current?.roomTypeConformationModalData
                    ?.userIsEnabled
                    ? " Enabled "
                    : " Disabled "} Successfully !
                </p>
              </div>
            )}
          </>
        }
      />
    </>
  )
}

export default EnableDisablePartnerConfig;